import {MenuItemActionBase} from "../menu-item-action-base";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IMenuItemConfigReader} from "../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";

export default class TransactionHistoryAction extends MenuItemActionBase {
    constructor(configReader: IMenuItemConfigReader, services: IServiceFactoryExtended) {
        super("transactionHistoryMenuItem", configReader, services);
    }

    protected async _onClick(): Promise<void> {
        await this.services.cashier.openTransactionHistory(
            {
                channel: {
                    source: CHANNEL_SOURCE.casinoClient,
                    area: AreaType.UserArea,
                    element: CHANNEL_ELEMENTS.transactionHistoryButton
                }
            }
        );
    }
}